import Mot from './mot';
import Service from './service';
import SubscriberBar from './subscriber-bar';

export const MotReminder = Mot;
export const ServiceReminder = Service;
export const SubscriberBarReminder = SubscriberBar;
